import React, { useEffect, useState } from "react";
import {  useLocation, useNavigate } from "react-router-dom";
// import { motion } from "framer-motion";
import styled from "styled-components";
import tw from "twin.macro";
import { getPageProductType } from "api/ProductTypeApi";
import { ProductCateCountApi } from "api/ProductCategoryApi";
// import { ECommerce } from "api/AppConfigApi";
import SEO from "./Seo";
import all from "../../images/Thanshiq/navbar/category/necklace.png"
import earing from "../../images/Thanshiq/navbar/category/earings.png"
// import diamond from "../../images/Thanshiq/navbar/category/dimand.png";
// import gold from "../../images/Thanshiq/navbar/category/gold.png"
// import wedding from "../../images/Thanshiq/navbar/category/wedding-ring.png"
// import more from "../../images/Thanshiq/navbar/category/more.svg"
// import gift from "../../images/Thanshiq/navbar/category/gift.svg"
import dimondr from "../../images/Thanshiq/navbar/category/dimand.png"
// import dailywar from "../../images/Thanshiq/navbar/category/dailywar.svg"
// import collection from "../../images/Thanshiq/navbar/category/collection.svg"
import ring from "../../images/Thanshiq/navbar/category/ring.png"
// import diamand from "../../images/Thanshiq/navbar/Diamond.svg"

import Bangles from "../../images/Thanshiq/category/Bangles.jpg"
import Chains from "../../images/Thanshiq/category/Chains.jpg"
import Earring from "../../images/Thanshiq/category/Earingspn.jpg"
import Mangalsutra from "../../images/Thanshiq/category/Mangalsutra.jpg"
import Necklaces from "../../images/Thanshiq/category/Necklaces.jpg"
import NecklaceSet from "../../images/Thanshiq/category/NecklaceSet.jpg"
import NosePin from "../../images/Thanshiq/category/Nose Pin.jpg"
import Pendants from "../../images/Thanshiq/category/Pendants.jpg"
import bracelats from "../../images/Thanshiq/category/Bracelats.jpg"

import kid from "../../images/Thanshiq/navbar/category/kid.jpg"
import men from "../../images/Thanshiq/navbar/category/Men.jpg"
import women from "../../images/Thanshiq/navbar/category/Womans.jpg"

import engagementRing from "../../images/Thanshiq/navbar/category/engagementRing.jpg"
import menRing from "../../images/Thanshiq/navbar/category/menRing.jpg"
import white from "../../images/Thanshiq/navbar/category/white.png"
import yellow from "../../images/Thanshiq/navbar/category/yellow.png"
import rose from "../../images/Thanshiq/navbar/category/Rose.png"

import dimondprice1 from "../../images/Thanshiq/navbar/category/diamond-25k-50k-hr.webp"
import dimondprice2 from "../../images/Thanshiq/navbar/category/diamond-50k-1l-hr.webp"
import diomondprice3 from "../../images/Thanshiq/navbar/category/diamond-1l-hr.webp"
import dimondpricefirst from "../../images/Thanshiq/navbar/category/diamond-below-25k-hr.webp"

import couplering from "../../images/Thanshiq/navbar/category/couplering.png"
import allRings from "../../images/Thanshiq/navbar/category/AllRings.png"
import casualRings from "../../images/Thanshiq/navbar/category/Casual Rings.png"
// import engagementrings from "../../images/Thanshiq/navbar/category/EngagementRings.jpg"
import platinumrings from "../../images/Thanshiq/navbar/category/PlatinumRings.png"
import mensrings from "../../images/Thanshiq/navbar/category/MensRings.jpg"
import goldEngagementRings from "../../images/Thanshiq/navbar/category/GoldEngagementRings.png"
import diamondEngagementRings from "../../images/Thanshiq/navbar/category/DiamondEngaRing.jpg"

import collection1 from "../../images/Thanshiq/navbar/category/collection1.webp"
import cln2 from "../../images/Thanshiq/navbar/category/collection2.webp"
import cln3 from "../../images/Thanshiq/navbar/category/collection3.webp"
import cln4 from "../../images/Thanshiq/navbar/category/collection4.jpg"
import cln5 from "../../images/Thanshiq/navbar/category/collection5.webp"
import cln6 from "../../images/Thanshiq/navbar/category/collection6.webp"
import cln7 from "../../images/Thanshiq/navbar/category/collection7.jpg"
import cln8 from "../../images/Thanshiq/navbar/category/collection8.webp"

import { getAllProductCate } from "api/ProductCategoryApi";
import { getAllProductSubCate } from "../../api/ProductSubCateApi";
// import { useCategory } from "../CategoryProvider";
// import { genderBasedIcons } from "components/GenderBasedIcons";
// import { getProductCate } from "../../api/ProductCategoryApi";
import { filterFormatToDate } from "utility/Constant.js";
import moment from "moment";
import { getBranchId } from "utility/HeaderConfig";
import { getProduct, orderStatus } from "api/ProductApi";
// import dailywearbottom from "../../images/Thanshiq/dailywear-menu-bottom-hr.webp"
import "@fontsource/ibm-plex-sans";
// import wbangles from "../../images/Thanshiq/wedding/bangles.jpg"
// import wchoker from "../../images/Thanshiq/wedding/choker.jpg"
// import wdiamond from "../../images/Thanshiq/wedding/diamond.jpg"
// import wharam from "../../images/Thanshiq/wedding/haram.jpg"
// import wmangalsutras from "../../images/Thanshiq/wedding/mangalsutras.jpg"
// import SideArrow from "../../images/Thanshiq/Sidearrow.svg"

export const NavLink = tw.span`my-2 tracking-wide transition duration-300 text-black hover:text-custom-100  pb-2 lg:pb-5 no-underline border-b-4 border-transparent hover:border-custom-100 text-base lg:text-sm lg:mx-4 lg:my-0 xl:text-base xl:mx-6`;

export const LogoLink = styled(NavLink)`
  ${tw`py-2`};
  img {
    ${tw`mr-3`}
  }
`;

export default function CategorysMenu() {
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get('type');
  //eslint-disable-next-line
  const [category, setCategory] = useState([]);

  const [subcategory, setSubCategory] = useState([]);
  const [data, setData] = useState([]);
  // const [diamondData, setDiamondData] = useState([]);
  const [count, setCount] = useState([]);

  const [lists] = useState([
    "gold", "silver", "diamond", "platinum"
  ]);
  const [state, setState] = useState({ isTechWalletEnable: false })
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const [isGoldHovered, setIsGoldHovered] = useState(false);
  const [isDiamondHovered, setIsDiamondHovered] = useState(false);
  const [isEarringsHovered, setIsEarringsHovered] = useState(false);
  const [isRingsHovered, setIsRingsHovered] = useState(false);
  const [isDailyWearHovered, setIsDailyWearHovered] = useState(false);
  const [isCollectionHovered, setIsCollectionHovered] = useState(false);
  const [isWeddingHovered, setIsWeddingHovered] = useState(false);
  const [isGiftingHovered, setIsGiftingHovered] = useState(false);
  const [isMoreHovered, setIsMoreHovered] = useState(false);
  const [isCategoryHovered, setIsCategoryHovered] = useState(false);
  const [listLoading, setListLoading] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const [selectedList, setSelectedList] = useState({
    type: "",
    category: "",
    subCategory: "",
    gender: "",
    price: "",
    status: "available",
    minWt: "",
    minWtName: "",
    maxWt: "",
    maxWtName: "",
  });

  const [productCategory, setCategoryList] = useState([]);
  const [allCategoryList, setAllCategoryList] = useState([]);
  const [categoryType, setCategoryType] = useState([]);
  const [selectedPrice, setSelectedPrice] = useState(null);
  const [occationCate, setOccationCate] = useState([]);
  const [orderStatusSale, setOrderStatusSale] = useState([]);
  const [orderStatusTransfer, setOrderStatusTransfer] = useState([]);
  const [orderStatusSold, setOrderStatusSold] = useState([]);
  const [size, setSize] = useState(21);
  const [productList, setProductList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [productType, setProductType] = useState([]);
  const handleNavigate = (value) => {
    navigate('/ProductList', {
      state: {
        selectedPrice: value,
        saleId: orderStatusSale,
        transferId: orderStatusTransfer,
        soldId: orderStatusSold

      }
    });
  };

  const handleButtonClick = () => {
    navigate('/ProductList');
  };


  const getCategoryByType = async (typeId) => {
    setListLoading(true);
    let visibilityList = [];
    let filterData = {
      metaProdTypeEnty: typeId ? typeId : "",

      visibilityMode: 'WEB'
      // visibilityMode: "WEB_MOBILE,MOBILE",
    };
    if (filterData.metaProdTypeEnty === "") {
      delete filterData.metaProdTypeEnty;
    }
    await getAllProductCate(filterData).then((data) => {
      const productResponse = data.response;
      let imageList = productResponse.filter((img) => img.imageUrl !== '-')
      // let limitedData = productResponse.slice(0, 5)
      productResponse.map((item) => {
        if (item.categoryName.toLowerCase() === 'earrings') {
          getSubCategoryList(item);
        }
      })
      visibilityList = productResponse.filter(
        (item) =>
          item.visibilityMode === "WEB_MOBILE" ||
          item.visibilityMode === "MOBILE"
      );
      setCategoryType(visibilityList)
      setListLoading(false);
      setCategoryType(imageList)
    });
  };

  // const [isHovered, setIsHovered] = useState(false);
  const [hoveredCategory, setHoveredCategory] = useState("Category",);
  const [hoveredViewall, setHoverViewAll] = useState("View All");

  const getCategoryList = async () => {
    let filterData = { metaProdTypeEnty: type ? type : "" };
    if (filterData.metaProdTypeEnty === "") {
      delete filterData.metaProdTypeEnty;
    }
    await getAllProductCate(filterData).then((data) => {
      const productResponse = data.response;
      let limitedData = productResponse.slice(0, 150)
      let visibilityList = productResponse.filter(
        (item) => item.visibilityMode === "WEB_MOBILE" || item.visibilityMode === "MOBILE"
      );
      setCategoryList(limitedData);
    });
  };

  // useEffect(() => {
  //   getOurExclusiveData();
  // }, []);

  const getSubCategoryList = async (cateId) => {
    setListLoading(true);
    let filter = { id: cateId.id }
    await getAllProductSubCate(filter).then((data) => {
      const productResponse = data.response;
      setSubCategory(productResponse)
      setListLoading(false);
    });
  };


  const handleChange = (e) => {
    let target = e.target;
    let input = target.name;
    let value = target.value;
    let index = e.nativeEvent.target.selectedIndex;
    let text = e.nativeEvent.target[index].text;

    if (input === "type") {
      setSelectedList({
        ...selectedList,
        type: value,
        category: "",
        subCategory: "",
        typeName: text,
        categoryName: "",
        subCategoryName: "",
      });
    } else if (input === "category") {
      setSelectedList({
        ...selectedList,
        category: value,
        subCategory: "",
        categoryName: text,
        subCategoryName: "",
      });
    } else if (input === "subCategory") {
      setSelectedList({
        ...selectedList,
        subCategory: value,
        subCategoryName: text,
      });
    } else if (input === "gender") {
      setSelectedList({
        ...selectedList,
        gender: value,
        genderName: text,
      });
    }
    else if (input === "price") {
      setSelectedList({
        ...selectedList,
        price: value,
        priceName: text,
      })
    }
    else if (input === "status") {
      setSelectedList({
        ...selectedList,
        status: value,
        statusName: text,
      });
    }
  };
  const getOrderStatus = async () => {
    try {
      const data = await orderStatus({
        multiOrderStatus: "sale,Transferred,Sold",
      });

      if (!data || !data.response) {
        console.error("Invalid API response:", data);
        return;
      }
      const statusResponse = data.response;
      orderStatusSale.length = 0;
      orderStatusTransfer.length = 0;
      orderStatusSold.length = 0;
      statusResponse.forEach((item) => {
        const status = item.orderStatusName.toLowerCase();
        if (status === "sale") {
          orderStatusSale.push(item.id);
        } else if (status === "transferred") {
          orderStatusTransfer.push(item.id);
        } else if (status === "sold") {
          orderStatusSold.push(item.id);
        }
      });

      setOrderStatusSale(orderStatusSale);
      setOrderStatusTransfer(orderStatusTransfer);
      setOrderStatusSold(orderStatusSold);
    } catch (err) {
      console.error("API Error:", err);
    }
  };

  const genderImages = [
    {
      title: "MALE",
      imgageSrc: men,
      gender: "M",
    },
    {
      title: "FEMALE",
      imgageSrc: women,
      gender: "F",
    },
    // {
    //   title: "COUPLE",
    //   imgageSrc: couple,
    //   gender: "C",
    // },
    {
      title: "KIDS",
      imgageSrc: kid,
      gender: "K",
    },
    // {
    //   title: "UNISEX",
    //   imgageSrc: couple,
    //   gender: "U",
    // },
  ]

  const goldCategory = [
    { img: Bangles, title: "Bangales" },
    { img: bracelats, title: "Bracelets" },
    { img: Earring, title: "Earrings" },
    { img: Chains, title: "Gold Chains" },
    { img: Pendants, title: "Pendants" },
    { img: ring, title: "Rings" },
    { img: bracelats, title: "Engagement Rings" },
    { img: Necklaces, title: "Necklaces" },
    { img: NosePin, title: "Nose Pins" },
    { img: bracelats, title: "Kadas" },
    { img: Mangalsutra, title: "Mangalsutras" },
    { img: bracelats, title: "Jhumkas" },
  ]
  const metalCategoryImages = [
    { img: yellow, text: "Rose" },
    { img: white, text: "White" },
    { img: rose, text: "Yellow" },

  ];

  const DiamondCategoryImages = [
    { img: Bangles, text: "Bangles" },
    { img: bracelats, text: "Bracelets" },
    { img: Earring, text: "Earrings" },
    { img: Mangalsutra, text: "Mangalsutras" },
    { img: NecklaceSet, text: "Neclklaces Set" },
    { img: Necklaces, text: "Neclklaces" },
    { img: NosePin, text: "Nose Pins" },
    { img: Pendants, text: "Pendants" },
    { img: Bangles }
  ];

  const DiamondPriceCategorym = [

    { img: dimondpricefirst, text: "<25K", value: "below-25000" },
    { img: dimondprice1, text: "25K-50K", value: "25000-50000" },
    { img: dimondprice2, text: "50K-1L", value: "50000-100000" },
    { img: diomondprice3, text: "1L-Above", value: "100000-2500000" },
  ];
  const EarringCategory = [
    { img: Bangles, text: "All Earrings" },
    { img: bracelats, text: "Drop & Danglers" },
    { img: Earring, text: "Hoop & Huggies" },
    { img: earing, text: "Jhumkas" },
    { img: Necklaces, text: "Studs & Tops" },
  ]

  const RingCategory = [
    { img: allRings, text: "All Rings" },
    { img: casualRings, text: "Casual Rings" },
    { img: couplering, text: "Couple Rings" },
    { img: diamondEngagementRings, text: "Diamond Engagement Rings" },
    { img: engagementRing, text: "Engagement Rings" },
    { img: goldEngagementRings, text: "Gold Engagement Rings" },
    { img: mensrings, text: "Men's Rings" },
    { img: platinumrings, text: "Platinum Engagement Rings" },

  ]

  const DailyWearCategory = [
    { img: NecklaceSet, text: "nose pins" },
    { img: Chains, text: "chain" },
    { img: bracelats, text: "bracelets" },
    { img: menRing, text: "ring" },
    { img: Mangalsutra, text: "mangalsutras" },
    { img: Pendants, text: "Pendants" },

  ]

  const collectionViewAll = [
    { img: collection1, text: "Unbound" },
    { img: cln2, text: "Joy Of Dressing" },
    { img: cln3, text: "Aalo" },
    { img: cln4, text: "Enchanted Trails" },
    { img: cln5, text: "The Spotlight Edit" },
    { img: cln6, text: "Nav-raani" },
    { img: cln7, text: "GalmGays" },
    { img: cln8, text: "Celeste" },
  ]

  const routes = [
    "/NewArrivals",
    "/TrendOnShopComponent",
    "/OccasionCategoriesComponent",
  ];

  const toggleMobileMenu = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  useEffect(() => {
    Promise.all([
      getProductType(),
      getCategoryList(),
      getAllCategoryList(),
      getOrderStatus(),
      getOrderStatusSale(),
      getOrderStatusTransfer(),
      getOrderStatusSold(),
      getCategoryByType(),
      getProductSub(),
    ])

    // getTechWalletConfigData();
    //eslint-disable-next-line
  }, []);

  const getAllCategoryList = async () => {
      // setListLoading(true);
      let visibilityList = [];
      let filterData = {
        metaProdTypeEnty: selectedList.type ? selectedList.type : "",
        // visibilityMode: "WEB_MOBILE,MOBILE",
      };
      if (filterData.metaProdTypeEnty === "") {
        delete filterData.metaProdTypeEnty;
      }
      await getAllProductCate(filterData).then((data) => {
        const productResponse = data.response;
        visibilityList = productResponse.filter(
          (item) =>
            item.visibilityMode === "WEB_MOBILE" ||
            item.visibilityMode === "MOBILE"
        );
        setAllCategoryList(visibilityList);
        // setListLoading(false);
      });
    };

  useEffect(() => {
    if (type) {
      getCategoryList();
    }
    //eslint-disable-next-line
  }, [type]);

  const getOrderStatusSale = () => {
    return orderStatus({ orderStatusName: "sale" })
      .then((data) => {
        return data.response[0].id;
      })
      .catch((err) => console.error(err));
  }

  const getOrderStatusTransfer = () => {
    return orderStatus({ orderStatusName: "Transferred" })
      .then((data) => {
        return data.response[0].id;
      })
      .catch((err) => console.error(err));
  };

  const getOrderStatusSold = () => {
    return orderStatus({ orderStatusName: "Sold" })
      .then((data) => {
        return data.response[0].id;
      })
      .catch((err) => console.error(err));
  };

  const getProductCount = (productId) => {
    let filter = {
      visibilityMode: "MOBILE",
      productType: productId,
      allowCatalogue: 1,
    };
    ProductCateCountApi(filter).then((data) => {
      setCount(data.response);
    });
  };

  // const getTechWalletConfigData = async () => {
  //   const appConfigResData = await ECommerce('techwallet_config');
  //   if (appConfigResData.response&& appConfigResData.response.moduleField) {
  //     const moduleData = JSON.parse(appConfigResData.response.moduleField);
  //     moduleData.forEach((item) => {
  //       if (item.key === "IS_TECHWALLET_ENABLED")
  //         setState({ isTechWalletEnable: item.value });
  //     });
  //   }
  // };
  // const getProductType = () => {
  //   getPageProductType({}).then((data) => {
  //     let response = data.response.content;
  //     let filterData = response.filter((data) => {
  //       if (data.metaProductCategoryList.length > 0) {
  //         const typeName = data.name.toLowerCase().trim();
  //         return (
  //           typeName === "gold" ||
  //           typeName === "silver" ||
  //           // typeName === "silver articles" ||
  //           typeName === "gift articles" ||
  //           typeName === "diamond" ||
  //           typeName === "platinum"
  //         );
  //       }
  //       else
  //       {
  //         return false
  //       }
  //     });
  //     filterData.reverse()
  //     setData(filterData);
  //   });
  // };

  const getProductType = async () => {
    const arr1 = [];
    const arr2 = [];
    let isChecked = false
    let equlprod = []
    let notEqulprod = []

    let filterData = {
      active: 1
    }
    let pList = [];
    setListLoading(true);
    await getPageProductType({ active: 1 }).then((data) => {
      setListLoading(true);
      productType.length = 0;
      let response = data.response.content;
      pList = response.filter(
        (data) => data.metaProductCategoryList.length > 0 && data.id
      );
      pList.reverse();
      for (let index = 0; index < pList.length; index++) {
        productType.push(pList[index]);
      }
      setProductType(productType);
      setListLoading(false);
    });

    getPageProductType(filterData).then((data) => {
      let response = data.response.content;
      lists.forEach((item, idx) => {
        if (!isChecked) {
          equlprod.length = 0
          arr1.push(...response.filter((x) => x.name.toLowerCase() === item))
          arr2.push(...response.filter((x) => x.name.toLowerCase() !== item))
          isChecked = true
        } else {
          arr1.push(...arr2.filter((x) => x.name.toLowerCase() === item))
          const newarr = arr2
          notEqulprod = newarr.filter((x) => (x.name).toLowerCase() !== item)
          arr2.length = 0
          arr2.push(...notEqulprod)
        }
        if (lists.length - 1 === idx) {
          arr1.push(...arr2)
        }
      })
      // const pageData =  response.reverse()
      // let cropData= pageData.slice(0,5)
      let cropData = arr1.slice(0, 6)
      setData(cropData);

    })
  }

  const hoverProductDetails = (itemData) => {
    setIsGiftingHovered(true)
    if (itemData === 'gifts') {
      setHoveredCategory("Gifts for")
    } else {
      setHoveredCategory(itemData)
    }
  }

  const hoverLeaveProduct = () => {
    setIsGiftingHovered(false)
    setHoveredCategory('Category')
  }
  const [productSubCate, setProductSubCate] = useState();

  const handleGenderSelection = (gender) => {
    navigate("/ProductList", {
      state: {
        selectedGender: gender,
        saleId: orderStatusSale,
        transferId: orderStatusTransfer,
        soldId: orderStatusSold
      }
    });
  };

  // const getOurExclusiveData = () => {
  //   getProductCate({
  //     visibilityMode: "DESIGN",
  //   })
  //     .then((data) => {
  //       setOccationCate(data.response.content);
  //     })
  //     .catch((err) => {
  //       console.error(err);
  //     });
  // };
  const handleClose = () => setShow(false);

  const getProductList = () => {
    handleClose(true)
    setLoading(true);
    let filterData = {
      totalAmtFrom: selectedList.minValue,
      totalAmtTo: selectedList.maxValue,
      removeNTP: "NTP-",
      removeHP: "HP-",
      beforeCreatedAt: filterFormatToDate(moment().format('YYYY-MM-DD')),
      branch: getBranchId(),
      metaProdTypeEnty:
        selectedList && selectedList?.category?.metaProdType
          ? selectedList.category.metaProdTypeId
          : "",
      metaProdCateEnty: selectedList.category || '',
      productSubcategory: selectedList.subCategory || '',
      userType: selectedList.gender || "",
      allowCatalogue: 1,
      productDemoStatus: "Available_For_Demo,Demo_Completed,Demo_Cancelled",
      statusId:
        selectedList.status === "allStatus"
          ? `${orderStatusSale},${orderStatusTransfer},${orderStatusSold}`
          : `${orderStatusSale},${orderStatusTransfer}`,
    };

    Object.keys(filterData).forEach((key) => {
      if (filterData[key] === "") delete filterData[key];
    });
    if (
      orderStatusSale.length > 0 &&
      orderStatusTransfer.length > 0 &&
      orderStatusSold.length > 0
    ) {
      getProduct(size, filterData)
        .then((data) => {
          if (typeof data.response === "string") {
            let parsedResponse = JSON.parse(data.response);

            setProductList(parsedResponse.content);
          } else {
            setProductList(data.response.content);
          }
          setLoading(false);
        })
        .catch((err) => {
          console.error("Product API Error:", err);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  };
  const getProductSub = async () => {
    setListLoading(true);
    let filterData = {
      metaProdTypeEnty: selectedList.type ? selectedList.type : "",
      metaProdCateEnty: selectedList.category ? selectedList.category : "",
    };
    if (filterData.metaProdTypeEnty === "") {
      delete filterData.metaProdTypeEnty;
    }
    if (filterData.metaProdCateEnty === "") {
      delete filterData.metaProdCateEnty;
    }
    await getAllProductSubCate(filterData).then((data) => {
      let response = data.response;
      setProductSubCate(response);
      setListLoading(false);
    });
  };

  const productCategories = [
    "bracelets", "rings", "pendants", "stud", "mangalsutras",
    "bangles", "coin", "leg chain", "jhumkas", "nose pin",
    "earrings", "chain", "d bracelets"
  ];

  // Step 1: Filter and normalize valid categories
  const filtered = Array.from(
    new Set(
      productCategory
        .filter((item) =>
          productCategories.includes(item.categoryName?.toLowerCase().trim())
        )
        .map((item) => item.categoryName)
    )
  ).map((categoryName) =>
    productCategory.find((item) => item.categoryName === categoryName)
  );


  const chunkSize = Math.ceil(filtered.length / 3);

  const groups = [];
  for (let i = 0; i < filtered.length; i += chunkSize) {
    groups.push(filtered.slice(i, i + chunkSize));
  }

  const goldCategoryP = ["bangles", "chain", "ring", "stud", "bracelets",
    "pendants", "coin", "mangalsutras", "earrings", "nose pin",
    "jhumkas", "d bracelet"];

  const goldFiltered = Array.from(
    new Set(
      productCategory
        .filter((item) =>
          goldCategoryP.includes(item.categoryName?.toLowerCase().trim())
        )
        .map((item) => item.categoryName)
    )
  ).map((categoryName) =>
    productCategory.find((item) => item.categoryName === categoryName)
  );

  const goldSize = Math.ceil(goldFiltered.length / 3);

  const goldGroups = [];
  for (let i = 0; i < goldFiltered.length; i += goldSize) {
    goldGroups.push(goldFiltered.slice(i, i + goldSize));
  }
  const diamondCategory = [
    "diamond ring", "d bracelets", "nose pin", "mangalsutras", "earrings",
    "chain", "pendants", "ring", "bangles", "bracelets"
  ]

  const diamondCategoryP = Array.from(
    new Set(
      productCategory
        .filter((item) =>
          diamondCategory.includes(item.categoryName?.toLowerCase().trim())
        )
        .map((item) => item.categoryName)
    )
  ).map((categoryName) =>
    productCategory.find((item) => item.categoryName === categoryName)
  );

  const diamondSize = Math.ceil(diamondCategoryP.length / 4);

  const diamondGroups = [];
  for (let i = 0; i < diamondCategoryP.length; i += diamondSize) {
    diamondGroups.push(diamondCategoryP.slice(i, i + diamondSize));
  }

  const earringCategory = [
    "jhumkas", "stud", "drops"
  ]

  const earringCategoryP = Array.from(
    new Set(
      productCategory
        .filter((item) =>
          earringCategory.includes(item.categoryName?.toLowerCase().trim())
        )
        .map((item) => item.categoryName)
    )
  ).map((categoryName) =>
    productCategory.find((item) => item.categoryName === categoryName)
  );

  const earringSize = Math.ceil(earringCategoryP.length / 4);

  const earringGroups = [];
  for (let i = 0; i < earringCategoryP.length; i += diamondSize) {
    earringGroups.push(earringCategoryP.slice(i, i + diamondSize));
  }

  const ringCategory = [
    "diamond ring", "ring"
  ]

  const ringCategoryP = Array.from(
    new Set(
      productCategory
        .filter((item) =>
          ringCategory.includes(item.categoryName?.toLowerCase().trim())
        )
        .map((item) => item.categoryName)
    )
  ).map((categoryName) =>
    productCategory.find((item) => item.categoryName === categoryName)
  );

  const ringSize = Math.ceil(ringCategoryP.length / 4);

  const ringGroups = [];
  for (let i = 0; i < ringCategoryP.length; i += ringSize) {
    ringGroups.push(ringCategoryP.slice(i, i + ringSize));
  }

  const dailyWearCategorys = ["chain", "bracelets", " earrings", "ring", "mangalsutras", "pendants", "ring", "nose pins"]
  const dailyWearCategoryP = productCategory
    .filter((item) => {
      const categoryLower = item.categoryName?.toLowerCase().trim();
      return categoryLower && dailyWearCategorys.includes(categoryLower);
    })
    .reduce((unique, item) => {
      // Check if the item is already in the unique array
      if (!unique.some(entry => entry.categoryName === item.categoryName)) {
        unique.push(item);
      }
      return unique;
    }, []);

  const dailyWearSize = Math.ceil(dailyWearCategoryP.length / 4);

  const dailyWearGroups = [];
  for (let i = 0; i < dailyWearCategoryP.length; i += dailyWearSize) {
    dailyWearGroups.push(dailyWearCategoryP.slice(i, i + dailyWearSize));
  }

  const goldMenCategory = [
    "chain", "bracelets", " earrings", "diamond ring", "mangalsutras", "pendants", "ring",];

  const goldMenCategoryFilter = productCategory
    .filter((item) => {
      const categoryLower = item.categoryName?.toLowerCase().trim();
      return categoryLower && goldMenCategory.includes(categoryLower);
    })
    .reduce((unique, item) => {

      if (!unique.some(entry => entry.categoryName === item.categoryName)) {
        unique.push(item);
      }
      return unique;
    }, []);

  const goldMenCategorySize = Math.ceil(goldMenCategoryFilter.length / 4);

  const goldMenCategoryGroups = [];
  for (let i = 0; i < goldMenCategoryFilter.length; i += goldMenCategorySize) {
    goldMenCategoryGroups.push(goldMenCategoryFilter.slice(i, i + goldMenCategorySize));
  }

  const ringSubCategory = [
    "diamond ring", "ladies ring", "choker", "3 grms ring", "fancy ring", "alphabets ring", "2 grm ring"
  ]

  const ringSubFilter = (productSubCate || [])
    .filter((item) => {
      const categoryLower = item.subCategoryName?.toLowerCase().trim();
      return categoryLower && ringSubCategory.includes(categoryLower);
    })
    .reduce((unique, item) => {

      if (!unique.some(entry => entry.subCategoryName === item.subCategoryName)) {
        unique.push(item);
      }
      return unique;
    }, []);

  const ringSubCategorySize = Math.ceil(goldMenCategoryFilter.length / 4);

  const ringSubCategoryGroups = [];
  for (let i = 0; i < ringSubFilter.length; i += ringSubCategorySize) {
    ringSubCategoryGroups.push(ringSubFilter.slice(i, i + ringSubCategorySize));
  }

  const goldCoinCategory = [
    "2 gram gold coin", "4 gm coin", "8 gm coin", "gold coin",]

  const goldCoinFilter = (productSubCate || [])
    .filter((item) => {
      const categoryLower = item.subCategoryName?.toLowerCase().trim();
      return categoryLower && goldCoinCategory.includes(categoryLower);
    })
    .reduce((unique, item) => {

      if (!unique.some(entry => entry.subCategoryName === item.subCategoryName)) {
        unique.push(item);
      }
      return unique;
    }, []);

  const goldCoinSize = Math.ceil(goldCoinFilter.length / 2);

  const goldCoinCategoryGroups = [];
  for (let i = 0; i < goldCoinFilter.length; i += goldCoinSize) {
    goldCoinCategoryGroups.push(goldCoinFilter.slice(i, i + goldCoinSize));
  }

  const metalCategory = [
    "rose gold", "silver articles", "gold"]

  const metalFilter = (productType || [])
    .filter((item) => {
      const categoryLower = item.name?.toLowerCase().trim();
      return categoryLower && metalCategory.includes(categoryLower);
    })
    .reduce((unique, item) => {

      if (!unique.some(entry => entry.name === item.name)) {
        unique.push(item);
      }
      return unique;
    }, []);

  const metalSize = Math.ceil(metalFilter.length / 2);

  const metalGroups = [];
  for (let i = 0; i < metalFilter.length; i += metalSize) {
    metalGroups.push(metalFilter.slice(i, i + metalSize));
  }

  const toPascalCase = (text) => {
    if (!text) return '';

    return text
      .toLowerCase()
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <>
      <SEO
        title="MGDM Jewels Pvt Ltd"
        description="Beginner friendly page for learning React Helmet."
        name="Company name."
        type="article"
      />
      <nav className="navbar navbar-expand-lg navbar-light bg-light sticky-top z-50">
        <div className="container-fluid">
          <button
            className="navbar-toggler"
            type="button"
            onClick={() => setIsMenuOpen((prev) => !prev)}
            aria-controls="navbarNav"
            aria-expanded={isMenuOpen}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>

          {/* Collapsible menu */}
          <div
            className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}ml-5`}
            id="navbarNav">
            <div className="d-flex flex-wrap justify-content-start gap-2 p-2"
            style={{marginLeft: '473px'}}>
              <div
                className="d-flex align-items-center position-relative nav-item"
                id="categorys-hover"
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                style={{ cursor: "pointer", padding: "2px" }}
              >
                <button className="btn d-lg-none" onClick={toggleMobileMenu}>
                  <img
                    src={all}
                    alt="Gold"
                    style={{ width: "20px", height: "20px", marginRight: "6px" }}
                    className="py-0"
                  />
                  All jewellers
                </button>

                {/* Desktop All Jewellers */}
                <div
                  className="d-none d-lg-flex nav-item py-0"
                  key={data.id}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!data?.id) {
                      console.error("Category ID is missing!");
                      return;
                    }
                    navigate(`/ProductList?category=${data.id}`, {
                      state: { category: data },
                    });
                  }}
                >
                  <span id="CateStyle">
                    <img

                      src={all}
                      alt="Gold"
                      style={{ width: "20px", height: "20px", marginRight: "5px" }}
                    />
                    All Jewellers
                  </span>
                </div>

                {(isHovered || isMobileOpen) && (
                  <div
                    id="cathover"
                    className="position-absolute bg-white shadow-lg p-3 rounded d-flex flex-column flex-lg-row"
                    style={{
                      top: "100%",
                      left: "120%", 
                      transform: "translateX(-50%)", 
                      width: "90vw",
                      maxWidth: "1100px",
                      overflowX: "auto",
                      zIndex: "1000",
                      border: "1px solid #ddd",
                    }}
                  >
                    <ul id="cathover" className="list-unstyled m-0 text-dark" style={{ width: "200px", borderRight: "1px solid #ddd" }}>
                      {["Category", "Gender"].map((item) => (
                        <li
                          id="subProductCate"
                          key={item}
                          className={`p-2 ${hoveredCategory === item ? "bg-light text-dark" : ""}`}
                          onMouseEnter={() => setHoveredCategory(item)}
                          style={{ cursor: "pointer" }}
                        >
                          {item}
                        </li>
                      ))}
                    </ul>

                    {hoveredCategory === "Category" && (
                      allCategoryList.map((group, groupIndex) => (
                        group.imageUrl !== '-' && (
                        <div
                          key={group.id}
                          className="d-flex flex-column gap-3 pl-2"
                          style={{
                            width: "300px",
                            height: "255px",
                            borderRight: "1px solid rgb(211, 195, 195)",
                            borderBottom: "1px solid rgb(211, 195, 195)"
                          }}
                        >
                          <button
                            className={`category-item text-dark-light text-start bg-transparent border-0 p-0 ${selectedList.subCategory === group?.id ? "fw-bold text-primary" : ""}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              navigate(`/ProductList?category=${group.id}`, {
                                state: {
                                  category: group,
                                  saleId: orderStatusSale,
                                  transferId: orderStatusTransfer,
                                  soldId: orderStatusSold,
                                },
                              });
                            }}
                          >
                            <div className="d-flex align-items-center" id="subProductCate">
                              <button className="d-flex align-items-center border-0 bg-transparent">
                                <span className="ms-2">
                                  <img
                                    src={group.imageUrl}
                                    style={{
                                      width: "30px",
                                      height: "30px",
                                      borderRadius: "50%"
                                    }}
                                    alt={group.categoryName}
                                  />
                                </span>
                                <p className="m-2">{toPascalCase(group?.categoryName)}</p>
                              </button>
                            </div>
                          </button>
                        </div>)
                      ))
                    )}
                    {hoveredCategory === "Gender" && (
                      <div className=" d-flex justify-content-start bg-white" style={{ width: "900px" }}>
                        {genderImages.map((image, index) => (
                          <div id="AllJho" key={index} style={{ width: "210px", height: "250px" }} className=" gap-4 p-2 text-center">
                            <img
                              src={image.imgageSrc}
                              alt={`Gender ${index + 1}`}
                              style={{ height: "190px", width: "150px" }}
                              className="w-100 rounded-3"
                              onClick={() => handleGenderSelection(image.gender)}
                            />
                            <p className="mt-2" id="subProductCate">{toPascalCase(image.title)}</p>
                          </div>
                        ))}
                      </div>
                    )}

                  </div>

                )}
              </div>
              {/* <div className="d-flex flex-wrap justify-content-start gap-2 py-0">
                {listLoading ? (
                  <div className="text-muted w-100 text-center">Loading...</div>
                ) : productType.length === 0 ? (
                  <div className="text-muted w-100 text-center">No Options</div>
                ) : (
                  productType
                    .filter((data) => data.name?.toLowerCase().trim() === "gold")
                    .map((data) => (
                      <div
                        className="m-2 position-relative"
                        key={data.id}
                        name="type"
                        value={data.id}
                        onMouseEnter={() => setIsGoldHovered(true)}
                        onMouseLeave={() => setIsGoldHovered(false)}>
                        <span id="CateStyle" style={{ cursor: "pointer" }}
                          onClick={() => {
                            setSelectedList((prev) => ({
                              ...prev,
                              type: data.id,
                            }));

                            navigate(`/ProductList?type=${data.id}`, {
                              state: {
                                type: data,
                                saleId: orderStatusSale,
                                transferId: orderStatusTransfer,
                                soldId: orderStatusSold
                              },
                            });
                          }}>
                          <img

                            src={gold}
                            alt="Gold"
                            style={{ width: "20px", height: "20px", marginRight: "6px" }}
                            className="py-0"
                          />
                          Gold</span>

                        {isGoldHovered && (
                          <div id="cathover" className="position-absolute bg-white shadow p-4 rounded d-flex" style={{
                            top: "100%",
                            left: "-150px",
                            transform: "none",
                            width: "90vw",
                            maxWidth: "1100px",
                            overflowX: "auto",
                            zIndex: "1000",
                            border: "1px solid #ddd",
                            cursor: "pointer"
                          }}>
                            <ul className="list-unstyled m-0 text-dark" id="gg" style={{ width: "200px", borderRight: "1px solid #ddd" }}>
                              {["Category"].map((item) => (
                                <li
                                  id="subProductCate"
                                  key={item}
                                  className={`p-2 ${hoveredCategory === item ? "bg-light text-dark" : ""}`}
                                  onMouseEnter={() => setHoveredCategory(item)}
                                  style={{ cursor: "pointer" }}
                                >
                                  {item}
                                </li>
                              ))}
                            </ul>

                            {hoveredCategory === "Category" && (
                              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>

                                <div className="d-flex flex-row justify-content-start" style={{ gap: "40px", borderBottom: "1px solid rgb(211, 195, 195)", width: "900px" }}>
                                  {Array.isArray(goldGroups) && goldGroups.length > 0 && goldGroups.map((group, groupIndex) => (
                                    <div

                                      key={groupIndex}
                                      className="d-flex flex-column gap-4"
                                      style={{ width: "300px", borderRight: "1px solid rgb(211, 195, 195)", }}
                                    >
                                      {group.map((item, itemIndex) => {
                                        const goldIndex = groupIndex * goldSize + itemIndex;
                                        const goldImg = goldCategory[goldIndex]?.img;

                                        return (
                                          <button

                                            key={item.id}
                                            className={`category-item  text-dark text-start bg-transparent border-0 p-0 ${selectedList.subCategory === item.id ? "fw-bold text-primary" : ""
                                              }`}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              navigate(`/ProductList?category=${item.id}`, {
                                                state: {
                                                  category: item,
                                                  saleId: orderStatusSale,
                                                  transferId: orderStatusTransfer,
                                                  soldId: orderStatusSold,
                                                },
                                              });
                                            }}
                                          >
                                            <div className="d-flex  align-items-center " id="subProductCate" >
                                              <button className="d-flex align-items-center border-0 bg-transparent">
                                                <span className="ms-2 ">
                                                  <img src={item.imageUrl} style={{ width: "30px", height: "30px", borderRadius: "50%" }} />
                                                </span>
                                                <span className="m-2"> {toPascalCase(item?.categoryName)} </span>
                                              </button>

                                            </div>
                                          </button>
                                        );
                                      })}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    ))
                )}
              </div> */}
              <div className="d-flex flex-wrap justify-content-center align-items-center gap-1 py-0">
                {productType.filter((item) => item.name?.toLowerCase().trim() === 'diamond')
                  .map((item) => (
                    <div className="d-flex align-items-center position-relative nav-item"
                      id="categorys-hover"
                      onMouseEnter={() => setIsDiamondHovered(true)}
                      onMouseLeave={() => setIsDiamondHovered(false)}
                      style={{ cursor: "pointer" }}>
                      <span
                        id="CateStyle"
                        className="px-2 py-1"
                        onClick={() => {
                          setSelectedList((prev) => ({
                            ...prev,
                            type: item.id,
                          }));
                          navigate(`/ProductList?type=${item.id}`, {
                            state: {
                              type: item,
                              saleId: orderStatusSale,
                              transferId: orderStatusTransfer,
                              soldId: orderStatusSold
                            },
                          });
                        }}>
                        <img src={dimondr} alt="Diamond" style={{ width: "18px", height: "18px", marginRight: "4px" }} />
                        Diamond
                      </span>
                      {isDiamondHovered && (
                        <div id="cathover" className="position-absolute bg-white shadow p-3 rounded d-flex" style={{
                          top: "100%",
                          left: "-225px",
                          width: "80vw",
                          maxWidth: "1100px",
                          overflowX: "auto",
                          zIndex: "1000",
                          border: "1px solid #ddd",
                          cursor: "pointer"
                        }}>
                          <ul className="list-unstyled m-0 text-dark" style={{ width: "180px", borderRight: "1px solid #ddd" }}>
                            {["Category", "Gender"].map((item) => (
                              <li
                                id="subProductCate"
                                key={item}
                                className={`p-2 ${hoveredCategory === item ? "bg-light text-dark" : ""}`}
                                onMouseEnter={() => setHoveredCategory(item)}
                                style={{ cursor: "pointer", fontWeight: "500" }}
                              >
                                {item}
                              </li>
                            ))}
                          </ul>
                          {hoveredCategory === "Category" && (
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                              <div className="d-flex flex-row justify-content-start" style={{ width: "900px", height: "280px", gap: "40px", borderBottom: "1px solid rgb(211, 195, 195)" }}>
                                {Array.isArray(diamondGroups) && diamondGroups.length > 0 && diamondGroups.map((group, groupIndex) => (
                                  <div
                                    key={groupIndex}
                                    className="d-flex flex-column gap-4"
                                    style={{ width: "300px", marginRight: "10px", borderRight: "1px solid rgb(211, 195, 195)" }}
                                  >
                                    {group.map((item, itemIndex) => {
                                      const diamondIndex = groupIndex * diamondSize + itemIndex;
                                      const diamondImg = DiamondCategoryImages[diamondIndex]?.img;
                                      return (
                                        <button
                                          key={item.id}
                                          className={`category-item text-dark text-start bg-transparent border-0 p-0 ${selectedList.subCategory === item.id ? "fw-bold text-primary" : ""
                                            }`}
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            navigate(`/ProductList?category=${item.id}`, {
                                              state: {
                                                category: item,
                                                saleId: orderStatusSale,
                                                transferId: orderStatusTransfer,
                                                soldId: orderStatusSold,
                                              },
                                            });
                                          }}>
                                          <div className="d-flex align-items-center gap-3">
                                            <div
                                              className="rounded-circle bg-light d-flex justify-content-center align-items-center"
                                              style={{ width: "45px", height: "45px" }}
                                            >
                                              <img
                                                src={item.imageUrl}
                                                alt="icon"
                                                style={{ width: "30px", height: "30px", borderRadius: "50%" }}
                                              />
                                            </div>
                                            <p id="subProductCate">{toPascalCase(item.categoryName)}</p>
                                          </div>
                                        </button>
                                      );
                                    })}
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                          {hoveredCategory === "Gender" && (
                            <div className="p-1 d-flex flex-wrap" style={{ background: "#fff", width: "900px" }}>
                              {genderImages.map((image, index) => (
                                <div key={index} style={{ width: "250px", height: "250px" }} className=" p-2 text-center " id="AllJho">
                                  <img
                                    src={image.imgageSrc}
                                    alt={`Gender ${index + 1}`}
                                    style={{ height: "200px", width: "200px" }}
                                    className=" rounded-3 "
                                    onClick={() => handleGenderSelection(image.gender)}
                                  />
                                  <p id="subProductCate" className="mt-2">{toPascalCase(image.title)}</p>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ))
                }

                {/* <div className="d-flex align-items-center position-relative nav-item py-0"
                  id="categorys-hover"
                  onMouseEnter={() => setIsDailyWearHovered(true)}
                  onMouseLeave={() => setIsDailyWearHovered(false)}
                  style={{ cursor: "pointer" }}>
                  <span id="CateStyle" className="px-2 py-1">
                    <img src={dailywar} alt="Daily Wear" style={{ width: "18px", height: "18px", marginRight: "4px" }} />
                    Daily Wear
                  </span>

                  {isDailyWearHovered && (
                    <div id="cathover" className="position-absolute bg-white shadow p-3 rounded d-flex" style={{
                      top: "100%",
                      left: "50%",
                      transform: "translateX(-50%)",
                      width: "80vw",
                      maxWidth: "1100px",
                      zIndex: "1000",
                      border: "1px solid #ddd",
                      cursor: "pointer"
                    }}>
                      <ul className="list-unstyled m-0 text-dark" style={{ width: "180px", borderRight: "1px solid #ddd" }}>
                        {["Category"].map((item) => (
                          <li
                            id="subProductCate"
                            key={item}
                            className={`p-2 ${hoveredCategory === item ? "bg-light text-dark" : ""}`}
                            onMouseEnter={() => setHoveredCategory(item)}
                            style={{ cursor: "pointer", fontWeight: "500" }}
                          >
                            {item}
                          </li>
                        ))}
                      </ul>

                      {hoveredCategory === "Category" && (
                        <div className="p-3 d-flex flex-wrap" style={{ background: "#f8f9fa", width: "900px", height: "200px" }}>
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                            <div className="d-flex flex-row justify-content-start" style={{ gap: "40px", borderBottom: "1px solid rgb(211, 195, 195)" }}>
                              {Array.isArray(dailyWearGroups) && dailyWearGroups.length > 0 && dailyWearGroups.map((group, groupIndex) => (
                                <div
                                  key={groupIndex}
                                  className="d-flex flex-column gap-4"
                                  style={{ width: "200px", borderRight: "1px solid rgb(211, 195, 195)" }}
                                >
                                  {group.map((item, itemIndex) => {
                                    const dailyWearItem = DailyWearCategory.find(
                                      dw => dw.text.trim().toLowerCase() === item.categoryName.trim().toLowerCase()
                                    );
                                    const dailyWearImg = dailyWearItem?.img;

                                    return (
                                      <button
                                        key={item.id}
                                        className={`category-item text-dark text-start bg-transparent border-0 p-0 ${selectedList.subCategory === item.id ? "fw-bold text-primary" : ""
                                          }`}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          navigate(`/ProductList?category=${item.id}`, {
                                            state: {
                                              category: item,
                                              saleId: orderStatusSale,
                                              transferId: orderStatusTransfer,
                                              soldId: orderStatusSold,
                                            },
                                          });
                                        }}
                                      >
                                        <div className="d-flex align-items-center gap-3">
                                          <div
                                            className="rounded-circle bg-light d-flex justify-content-center align-items-center"
                                            style={{ width: "45px", height: "45px" }}
                                          >
                                            <img
                                              src={item.imageUrl}
                                              alt="icon"
                                              style={{ width: "30px", height: "30px", borderRadius: "50%" }}
                                            />
                                          </div>
                                          <span id="subProductCate" >{toPascalCase(item.categoryName)}</span>
                                        </div>
                                      </button>
                                    );
                                  })}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div> */}

                {/* <div className="d-flex align-items-center position-relative nav-item py-0"
                  id="categorys-hover"
                  onMouseEnter={() => setIsCollectionHovered(true)}
                  onMouseLeave={() => setIsCollectionHovered(false)}
                  style={{ cursor: "pointer" }}>
                  <span id="CateStyle" className="px-2 py-1">
                    <img src={collection} alt="Collections" style={{ width: "18px", height: "18px", marginRight: "4px" }} />
                    Collections
                  </span>

                  {isCollectionHovered && (
                    <div id="cathover" className="position-absolute bg-white shadow p-3 rounded d-flex"
                      style={{
                        top: "100%",
                        right: "-470px",
                        width: "80vw",
                        maxWidth: "1100px",
                        overflowX: "auto",
                        zIndex: "1000",
                        border: "1px solid #ddd",
                        cursor: "pointer"
                      }}>
                      <ul className="list-unstyled m-0 text-dark" style={{ width: "180px", borderRight: "1px solid #ddd" }}>
                        {["View All"].map((item) => (
                          <li
                            id="subProductCate"
                            key={item}
                            className={`p-2 ${hoveredCategory === item ? "bg-light text-dark" : ""}`}
                            onMouseEnter={() => setHoveredCategory(item)}
                            style={{ cursor: "pointer", fontWeight: "500" }}
                          >
                            {item}
                          </li>
                        ))}
                      </ul>

                      {hoveredViewall === "View All" && (
                        <div className="d-flex justify-content-between flex-wrap"
                          style={{ background: "#fff", width: "1000px", height: "450px" }}>
                          {collectionViewAll.map((image, index) => {
                            const targetRoute = routes[index % routes.length];
                            return (
                              <div
                                id="AllJho"
                                key={index}
                                style={{ width: "220px", height: "220px", textAlign: "center" }}
                              >
                                <img
                                  className="mt-1"
                                  src={image.img}
                                  alt={`Occasion ${index + 1}`}
                                  style={{ width: "180px", height: "180px", borderRadius: "15px" }}
                                  onClick={() => navigate(targetRoute)}
                                />
                                <p id="subProductCate" style={{ marginTop: "1px" }}>{image.text}</p>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  )}
                </div> */}

                {/* <div className="d-flex align-items-center position-relative py-0"
                  id="categorys-hover"
                  onMouseEnter={() => setIsWeddingHovered(true)}
                  onMouseLeave={() => setIsWeddingHovered(false)}
                  style={{ cursor: "pointer" }}>
                  <span id="CateStyle" className="px-2 py-1">
                    <img src={wedding} alt="Wedding" style={{ width: "18px", height: "18px", marginRight: "4px" }} />
                    Wedding
                  </span>
                  {isWeddingHovered && (
                    <div className="position-absolute bg-white shadow p-3 rounded d-flex"
                      style={{
                        top: "100%",
                        left: "-570px",
                        width: "80vw",
                        maxWidth: "1100px",
                        overflowX: "auto",
                        zIndex: "1000",
                        border: "1px solid #ddd",
                        cursor: "pointer"
                      }}>
                      <ul className="list-unstyled m-0 text-dark" style={{ width: "180px", borderRight: "1px solid #ddd" }}>
                        {["Category"].map((item) => (
                          <li
                            id="subProductCate"
                            key={item}
                            className={`p-2 ${hoveredCategory === item ? "bg-light text-dark" : ""}`}
                            onMouseEnter={() => setHoveredCategory(item)}
                            style={{ cursor: "pointer", fontWeight: "500" }}
                          >
                            {item}
                          </li>
                        ))}
                      </ul>
                      <div className="d-flex justify-content-start gap-4" >
                        {productCategory.filter((item) => item.categoryName?.toLowerCase().trim() === "bangles")
                          .map((item) => (
                            <div>
                              <img onClick={(e) => {
                                e.stopPropagation();
                                navigate(`/ProductList?category=${item.id}`, {
                                  state: {
                                    category: item,
                                    saleId: orderStatusSale,
                                    transferId: orderStatusTransfer,
                                    soldId: orderStatusSold,
                                  },
                                });
                              }} className="m-2" src={wbangles} style={{ width: "200px", height: "200px", borderRadius: "10px" }} />
                              <span onClick={(e) => {
                                e.stopPropagation();
                                navigate(`/ProductList?category=${item.id}`, {
                                  state: {
                                    category: item,
                                    saleId: orderStatusSale,
                                    transferId: orderStatusTransfer,
                                    soldId: orderStatusSold,
                                  },
                                });
                              }} id="subProductCate" className="d-flex justify-content-center">{toPascalCase(item.categoryName)}</span>
                            </div>
                          ))}
                        {productType.filter((data) => data.name?.toLowerCase().trim() === "diamond")
                          .map((data) => (
                            <div>
                              <img onClick={() => {
                                navigate(`/ProductList?type=${data.id}`, {
                                  state: {
                                    type: data,
                                    saleId: orderStatusSale,
                                    transferId: orderStatusTransfer,
                                    soldId: orderStatusSold
                                  },
                                });
                              }} className="m-2" src={wdiamond} style={{ width: "200px", height: "200px", borderRadius: "10px" }} />
                              <span onClick={() => {
                                navigate(`/ProductList?type=${data.id}`, {
                                  state: {
                                    type: data,
                                    saleId: orderStatusSale,
                                    transferId: orderStatusTransfer,
                                    soldId: orderStatusSold
                                  },
                                });
                              }} id="subProductCate" className="d-flex justify-content-center">{toPascalCase(data.name)}</span>
                            </div>
                          ))}
                        {productCategory.filter((item) => item.categoryName?.toLowerCase().trim() === "mangalsutras")
                          .map((item) => (
                            <div>
                              <img onClick={(e) => {
                                e.stopPropagation();
                                navigate(`/ProductList?category=${item.id}`, {
                                  state: {
                                    category: item,
                                    saleId: orderStatusSale,
                                    transferId: orderStatusTransfer,
                                    soldId: orderStatusSold,
                                  },
                                });
                              }} className="m-2" src={wmangalsutras} style={{ width: "200px", height: "200px", borderRadius: "10px" }} />
                              <span onClick={(e) => {
                                e.stopPropagation();
                                navigate(`/ProductList?category=${item.id}`, {
                                  state: {
                                    category: item,
                                    saleId: orderStatusSale,
                                    transferId: orderStatusTransfer,
                                    soldId: orderStatusSold,
                                  },
                                });
                              }} id="subProductCate" className="d-flex justify-content-center">{toPascalCase(item.categoryName)}</span>
                            </div>
                          ))}
                      </div>
                    </div>
                  )}
                </div> */}
                 <div
                  className="d-flex align-items-center position-relative py-0"
                  id="categorys-hover"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/About")}
                >
                  <span id="CateStyle" className="d-flex align-items-center px-2 py-1">
                    <img
                      src={dimondr}
                      alt="Best Sellers Icon"
                      style={{ width: "18px", height: "18px", marginRight: "4px" }}
                    />
                    About
                  </span>
                </div>
                <div
                  className="d-flex align-items-center position-relative py-0"
                  id="categorys-hover"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/NewArrivals")}
                >
                  <span id="CateStyle" className="d-flex align-items-center px-2 py-1">
                    <img
                      src={all}
                      alt="New Arrivals Icon"
                      style={{ width: "18px", height: "18px", marginRight: "4px" }}
                    />
                    New Arrivals
                  </span>
                </div>
                <div
                  className="d-flex align-items-center position-relative py-0"
                  id="categorys-hover"
                  style={{ cursor: "pointer" }}
                  onClick={() => 
                    navigate("/VelSeriesDetails", { 
                      state: { isDashboard: true } 
                    })
                  }
                >
                  <span id="CateStyle" className="d-flex align-items-center px-2 py-1">
                    <img
                      src={all}
                      alt="New Arrivals Icon"
                      style={{ width: "18px", height: "18px", marginRight: "4px" }}
                    />
                    108 Divine Vel Series
                  </span>
                </div>

                {/* <div
                  className="d-flex align-items-center position-relative py-0"
                  id="categorys-hover"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/BestSellingComponent")}
                >
                  <span id="CateStyle" className="d-flex align-items-center px-2 py-1">
                    <img
                      src={dimondr}
                      alt="Best Sellers Icon"
                      style={{ width: "18px", height: "18px", marginRight: "4px" }}
                    />
                    Best Sellers
                  </span> */}
                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      </nav>

    </>
  );
}

